import { render, staticRenderFns } from "./BaseTeamLink.vue?vue&type=template&id=4827a22d&scoped=true"
import script from "./BaseTeamLink.vue?vue&type=script&lang=js"
export * from "./BaseTeamLink.vue?vue&type=script&lang=js"
import style0 from "./BaseTeamLink.vue?vue&type=style&index=0&id=4827a22d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4827a22d",
  null
  
)

export default component.exports